import { acceptStringValue } from '../../field-viewer/shared-normalizers';
export const ecomCompanyNameViewer = {
    normalizeLoadedValue: acceptStringValue
};

//# sourceMappingURL=definition-viewer.js.map